import React from "react";
import { KontentRichText } from "../../../types";
import * as styles from "./SecondaryNavigation.module.css";
import { RichTextSemanticLinks } from "../../elements/RichTextSemanticLinks/RichTextSemanticLinks";

interface Props {
  links: KontentRichText;
}

export const SecondaryNavigation: React.FC<Props> = ({ links }) => {
  return (
    <nav className={styles.secondaryNavigation}>
      <RichTextSemanticLinks content={links} />
    </nav>
  );
};
